import MuiSwipeableDrawer from '@mui/material/SwipeableDrawer'
import { styled } from '@mui/system'
import Typography from '../../../atoms/typography'
import Button from '../../button'
import BHActiveFilters from '../active/active-filters'
import BHFilters from '../filters'

const ButtonOpener = styled(Button)`
	text-transform: lowercase;
	min-width: fit-content;
	font-family: var(--font-base-regular);
	border-right: 1px solid ${({ theme }) => theme.palette.common.black};
	margin-right: var(--spacing-2);
	padding-right: var(--spacing-2);
	min-height: 20px;
	letter-spacing: 0;
`

const SwipeableDrawer = styled(MuiSwipeableDrawer)`
	> .MuiPaper-root {
		top: 0;
		width: 100%;
	}
	${({ theme }) => theme.breakpoints.up('sm')} {
		.MuiPaper-root.MuiDrawer-paper {
			${({ theme }) => theme.scrollbar};
			min-height: calc((var(--vh, 1vh) * 100));
			width: 100%;
			max-width: var(--right-anchored-drawer-width);
			width: 100%;
		}
	}
`
const Container = styled('div')`
	display: flex;
	flex-direction: column;
	height: 100%;
	position: relative;
	overflow: auto;
	width: 100%;
	${({ theme }) => theme.scrollbar};
	padding: 0 var(--spacing-3) var(--spacing-4) var(--spacing-4);

	.MuiIconButton-root.iconClose {
		top: var(--spacing-4);
		right: var(--spacing-4);
	}
`

const Filters = styled(BHFilters)`
	max-width: 100%;
	border: 0;
	padding-bottom: 120px;
	.MuiPaper-root {
		&:first-of-type {
			border-top: 0px;
		}
		.MuiAccordionSummary-root {
			padding: var(--spacing-2) 0;
			&.Mui-expanded {
				border-bottom: 1px solid var(--color-grey50);
			}
		}
		.MuiAccordionDetails-root {
			display: flex;
			flex-direction: column;
			margin-top: 0px;
			margin-right: 30px;
			margin-bottom: 20px;
			min-height: 24px;
			padding: var(--spacing-3) 0 0;

			.MuiFormControlLabel-root {
				margin: 0;
				margin-bottom: var(--spacing-3);
				max-width: 95%;
				&:last-of-type {
					margin-bottom: 0;
				}

				.MuiCheckbox-root {
					height: 16px;
					padding-top: 2px;
					.MuiSvgIcon-root {
						width: 16px;
						height: 16px;
					}
				}

				.MuiTypography-root {
					line-height: 18px;
				}

				.MuiFormControlLabel-label {
					display: flex;
					justify-content: space-between;
					flex-grow: 1;
				}
			}
		}
	}
`

const TitleFilters = styled(Typography)`
	margin: var(--size-20) 0 0;
	padding: 16px 0 26px;
`

const ButtonClose = styled(Button)`
	right: 9px;
	top: 20px;
`

const ActiveFilters = styled(BHActiveFilters)`
	margin-bottom: 0;

	.MuiChip-root {
		border-color: var(--color-grey50);
		padding: var(--spacing-2);

		.MuiChip-label {
			font-weight: 400;
			text-transform: lowercase;
			font-size: var(--font-size-body2);
		}
	}
`

const ActionsWrapper = styled('div')`
	background-color: ${({ theme }) => theme.palette.white.main};
	width: 100%;
	/* box-shadow: 0 -9px 16px 0 rgb(0 0 0 / 6%); */
	position: fixed;
	bottom: 0;
	right: 0;
	z-index: 9;
	${({ theme }) => theme.breakpoints.up('sm')} {
		width: calc(var(--right-anchored-drawer-width));
	}
`

const ActionsInnerWrapper = styled('div')`
	margin: auto;
	display: flex;

	justify-content: center;
	.MuiButton-root {
		min-width: max-content;
		width: 100%;
		padding-top: 12px;
	}
`

export {
	ActionsWrapper,
	ActionsInnerWrapper,
	Filters,
	Container,
	TitleFilters,
	ButtonClose,
	ButtonOpener,
	ActiveFilters,
	SwipeableDrawer,
}
